import { makeAutoObservable } from "mobx";

export const SUPPORTED = ['it', 'en', 'fr', 'es', 'pt', 'de', 'ru', 'tr', 'ja', 'ko', 'zh', 'ar', 'hi'];

export class GameSettingsStore {
  language = 'it';

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
    const saved = localStorage.getItem('waifu_briscola_lang');
    const browser = navigator.language.split('-')[0];
    if (saved) this.language = saved;
    else if (SUPPORTED.includes(browser)) this.language = browser;
  }

  setLanguage(lang) {
    this.language = lang;
    localStorage.setItem('waifu_briscola_lang', lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }
}

